import { ChevronRightIcon } from "@heroicons/react/20/solid"
import classNames from "classnames"
import PropTypes from "prop-types"

const CardStat = ({ 
  children = null, 
  title, stat = "N/A", 
  meta = null, 
  icon = null, 
  handleClick = null 
}) => {
  const DynamicIcon = icon || null

  return (
    <div onClick={handleClick} className={classNames({ "cursor-pointer group": handleClick, "px-4": true })}>
      <h3 className="mb-1 text-indigo-600 dark:text-foreground text-md">{title}</h3>

      <div className="flex items-center">
        <div className="flex items-center mr-4">
          {DynamicIcon && <DynamicIcon className="hidden h-8 mr-2 text-indigo-800 dark:text-foreground sm:block" />}
          <h2 className="text-xl font-semibold">{stat}</h2>
        </div>

        <div className="flex">
          <div>{meta && <p className="text-sm text-gray-500">{meta}</p>}</div>
        </div>

        {handleClick && (
          <div className="ml-auto">
            <ChevronRightIcon className="w-8 h-8 text-gray-300 group-hover:text-blue-500" />
          </div>
        )}
      </div>

      {children && <div className="mt-2">{children}</div>}
    </div>
  )
}

CardStat.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  stat: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.node]),
  meta: PropTypes.string,
  icon: PropTypes.object,
  handleClick: PropTypes.func,
}

export default CardStat
